<template>
  <div class="shopping-list--manual-entries">
    <div class="box">
      <form v-on:submit.prevent="save">
        <div class="field">
          <label class="label">
            {{ $t("Individual item to shop") }}
          </label>
          <autocomplete
            :candidates="autoCompleteCandidates"
            :partialInput="ingredient"
            :suggestionCount="50"
            @candidate-selected="autocompleteCandidateSelected"
          />
          <div
            class="control shopping-list--manual-entries--input-ingredient-wrapper"
          >
            <input
              class="input shopping-list--manual-entries--input-ingredient"
              ref="inputIngredient"
              type="text"
              v-model="ingredient"
              :placeholder="$t('Salt')"
              @focus="inputFocused"
              @input="inputChanged"
            />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input
              type="submit"
              :value="$t('Add item')"
              class="button is-primary shopping-list--manual-entries--submit-button"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { ManualShoppingListEntry } from "@/models/ShoppingListEntry";
import Autocomplete from "@/components/Autocomplete";

export default Vue.extend({
  name: "ShoppingListManualEntryAdd",
  data() {
    return {
      ingredient: "",
    };
  },
  methods: {
    save: function () {
      this.$store.dispatch(
        "addManualShoppingListEntry",
        new ManualShoppingListEntry(this.ingredient.trim())
      );
      this.ingredient = "";
    },
    autocompleteCandidateSelected(candidate) {
      const shouldRestoreFocusToInput = this.ingredient !== "";
      this.ingredient = candidate;
      this.save();
      if (shouldRestoreFocusToInput) {
        this.$refs.inputIngredient.focus();
      }
    },
    inputFocused() {
      this.$el.scrollIntoView(false);
    },
    inputChanged(event) {
      // Manually reflect partial input in model
      // Firefox mobile only updates after each word, not letter otherwise!
      this.ingredient = event.target.value;
    },
  },
  computed: {
    autoCompleteCandidates() {
      const currentOpenEntries = this.$store.state.shoppingList.entries
        .filter((entry) => !entry.isShopped)
        .map((entry) => entry.ingredient.name);

      return [
        ...this.$store.state.shoppingList.entries,
        ...this.$store.state.shoppingList.historicEntries,
      ]
        .map((entry) => entry.ingredient.name)
        .map((candidate) => {
          const suffix = currentOpenEntries.indexOf(candidate) > -1 ? " ●" : "";
          return candidate + suffix;
        });
    },
  },
  components: {
    Autocomplete,
  },
});
</script>
<style>
.shopping-list--manual-entries {
  margin-bottom: 1.5rem;
}

.shopping-list--manual-entries--input-ingredient-wrapper {
  margin-bottom: 0.5rem;
}

.autocomplete {
  max-height: 4.4em;
  overflow: hidden;
}

.autocomplete .autocomplete--candidate__latest-selected {
  animation-name: glow;
  animation-duration: 1s;
}

@keyframes glow {
  from {
    color: #fff;
    background-color: #00d1b2;
  }
  to {
    color: #363636;
    background-color: white;
  }
}
</style>
<i18n>
{
  "en": {},
  "de": {
    "Individual item to shop": "Einzelner Eintrag",
    "Salt": "Salz",
    "Add item": "Eintrag hinzufügen"
  }
}
</i18n>
